
import React from "react";

function Humid() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <g clip-path="url(#clip0_649_29777)">
      <path d="M5.99945 1.3457L8.82945 4.1757C9.38913 4.73501 9.77035 5.44774 9.9249 6.22373C10.0795 6.99973 10.0004 7.80413 9.69772 8.53518C9.39505 9.26624 8.88236 9.89111 8.22451 10.3308C7.56666 10.7704 6.79319 11.0051 6.00196 11.0051C5.21072 11.0051 4.43725 10.7704 3.7794 10.3308C3.12155 9.89111 2.60886 9.26624 2.30619 8.53518C2.00351 7.80413 1.92445 6.99973 2.07901 6.22373C2.23356 5.44774 2.61478 4.73501 3.17445 4.1757L5.99945 1.3457Z" stroke="#6B7073" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.6988 8.53411C10.0015 7.80305 9.50049 7.99963 9.92598 7.22266H2.08008C2.30716 7.99963 2.00458 7.80305 2.30726 8.53411C2.60993 9.26517 3.12262 9.89004 3.78047 10.3297C4.43833 10.7693 5.21179 11.004 6.00303 11.004C6.79426 11.004 7.56773 10.7693 8.22558 10.3297C8.88343 9.89004 9.39612 9.26517 9.6988 8.53411Z" fill="#6B7073" stroke="#6B7073" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_649_29777">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  );
}
export default Humid;
